export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 4